import api from "services/api";
import { toSearchFilter } from "utils";
import { API_URL_VERSION } from "constants/environment";

export const ENDPOINT_AIT_BLOCKS_LIST = API_URL_VERSION + 'blocos-aits/listar'
export const ENDPOINT_AIT_BLOCKS = API_URL_VERSION + 'blocos-aits'
export const ENDPOINT_AIT_BLOCKS_GET_DETAIL_UPDATE_DELETE = API_URL_VERSION + 'blocos-aits/'
export const ENDPOINT_AIT_BLOCKS_GET_APPLICABILITIES = API_URL_VERSION + 'blocos-aits/aplicabilidades'

export const aitBlockService = {
    list: async (params = {}) => {
        try {
            const response = await api.post(ENDPOINT_AIT_BLOCKS_LIST, toSearchFilter(params));
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.ait-block.messages.errors.list";
        }
    },

    create: async (data) => {
        try {
            const response = await api.post(ENDPOINT_AIT_BLOCKS, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "settings.ait-block.messages.errors.create";
        }
    },

    find: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_AIT_BLOCKS_GET_DETAIL_UPDATE_DELETE}${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.ait-block.messages.errors.find";
        }
    },

    update: async (id, data) => {
        try {
            const response = await api.put(`${ENDPOINT_AIT_BLOCKS_GET_DETAIL_UPDATE_DELETE}${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "settings.ait-block.messages.errors.update";
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`${ENDPOINT_AIT_BLOCKS_GET_DETAIL_UPDATE_DELETE}${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.ait-block.messages.errors.delete";
        }
    },

    getApplicabilities: async (data) => {
        try {
            const response = await api.get(`${ENDPOINT_AIT_BLOCKS_GET_APPLICABILITIES}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.ait-block.messages.errors.get-applicabilities";
        }
    },
};